import React, { useEffect } from "react";
import { functions } from "../firebase/firebase";
import { httpsCallable } from "firebase/functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 

const StockStatusUpdater = ({ stockId, analysisStatus, analyzedOn }) => {

   const updateStatus = async (status,flag) => {

    const updatestat = httpsCallable(functions, "updatestat");
    
    
    const payload = { id: stockId,  
          status:status,
          flag:flag
    };
    try {
      const response = await updatestat(payload);
      if (response.data.success) {
         toast.success("Update status for the stock successful!",{
          position:"bottom-right"
         });
      } else {
         toast.error("Failed to update. Please try again.",{
          position:"bottom-right"
         });
      }
    } catch (error) {
      console.error("Error updating stock:", error);
      toast.error("Error updating stock.",{
        position:"bottom-right"
      }); 
    }
  };


  return (
    <div className="overflow-x-auto mb-10">
      <table className="min-w-full bg-white border border-gray-300 table-auto">
        <tbody>
          <tr className="bg-gray-100">
            <td className="px-4 py-2 font-semibold border border-gray-300 text-xs">
              <strong> Current Status:</strong>
            </td>
            <td
              colSpan="4"
              className="px-4 py-2 font-semibold border border-gray-300 text-xs"
            >
              {`${analysisStatus} ${analyzedOn}`}
            </td>
          </tr>
          <tr className="bg-white">
            <td className="px-4 py-2 font-semibold  border border-gray-300 focus:outline-none text-xs">
              <strong>Update status for the stock:</strong>
            </td>
            <td className="px-4 py-2 text-blue-700 border border-gray-300 text-xs">
              <a href="#" onClick={() => updateStatus("Analyzed", 0)}>
                Analyzed
              </a>
            </td>
            <td className="px-4 py-2 text-blue-700 border border-gray-300 text-xs">
              <a href="#" onClick={() => updateStatus("Shortlisted", 0)}>
                Shortlisted
              </a>
            </td>
            <td className="px-4 py-2 text-blue-700 border border-gray-300 text-xs">
              <a href="#" onClick={() => updateStatus("Good-But-Expensive", 0)}>
                Good-But-Expensive
              </a>
            </td>
            <td className="px-4 py-2 text-blue-700 border border-gray-300 text-xs">
              <a href="#" onClick={() => updateStatus("Purchased", 0)}>
                Purchased
              </a>
            </td>
          </tr>
          <tr className="bg-gray-100">
            <td className="px-4 py-2 font-semibold  border border-gray-300 text-xs">
              <strong>Dividend Potential:</strong>
            </td>
            <td className="px-4 py-2 text-blue-700 border border-gray-300 text-xs">
              <a href="#" onClick={() => updateStatus("Good Potential", 1)}>
                Good Potential
              </a>
            </td>
            <td className="px-4 py-2 text-blue-700 border border-gray-300 text-xs">
              <a href="#" onClick={() => updateStatus("Bad Potential", 1)}>
                Bad Potential
              </a>
            </td>
            <td className="border border-gray-300"></td>{" "}
            {/* Empty cell with a border */}
            <td className="border border-gray-300"></td>{" "}
            {/* Another empty cell with a border */}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default StockStatusUpdater;
